import { render, staticRenderFns } from "./BroadcastsOverlay.vue?vue&type=template&id=6ffe9204"
import script from "./BroadcastsOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroadcastsOverlay.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports